import React from 'react';
import loaging from '~/assets/images/loading.svg';
import './styles.css';

const Loading = () => {
    return (
        <div className="loading">
            <img src={loaging} alt="Loading..." />
        </div>
    )
}

export default Loading;